module.exports = __webpack_public_path__ + "static/media/Tall.628a4d52.PNG";